import { Button } from "primereact/button"
import { useNavigate } from 'react-router-dom';

export const Navigation = (props: any) => {
  const navigate = useNavigate();

  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container navbar'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <a className='navbar-brand page-scroll' href='#page-top'>
            <img className='logo navbarLogo' src={`/assets/img/logo-nav.svg`} alt="" />
          </a>{' '}
        </div>

        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
            {/* <li>
              <a href='#features' className='page-scroll'>
                ¿Quienes somos?
              </a>
            </li> */}
            <li>
              <a href='#about' className='page-scroll li-navbar'>
                ¿Quiénes somos?
              </a>
            </li>
            <li>
              <a href='#services' className='page-scroll li-navbar'>
                Servicios
              </a>
            </li>
            <li>
              <a href='#faqs' className='page-scroll li-navbar'>
                Preguntas frecuentes
              </a>
            </li>
            <li>
              <a href='#blog' className='page-scroll li-navbar'>
                Blog
              </a>
            </li>
            <li>
              <a href='#contact' className='page-scroll li-navbar'>
                Contacto
              </a>
            </li>
            <li>
              <button className='btn btn-success btn-block btn-lg page-scroll' onClick={() => navigate('/login')}>Iniciar sesión</button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}
